// src/components/BottomDockNavbar.js
import React from 'react';
import Dock from '../effects/Dock/Dock'; // From reactbits
import './BottomDockNavbar.css';

import {
  VscHome,
  VscBriefcase,
  VscProject,
  VscFeedback,
  VscSettingsGear,
  VscVmConnect,
  VscGitFetch,
  VscGithub,
  VscInbox,
  VscVscodeInsiders,
  VscTerminalPowershell,
} from 'react-icons/vsc';

const BottomDockNavbar = () => {
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const items = [
    {
      icon: <VscHome size={22} />,
      label: 'Home',
      onClick: () => scrollToSection('home'),
    },
    {
      icon: <VscTerminalPowershell size={22} />,
      label: 'techstack',
      onClick: () => scrollToSection('techstack'),
    },
    {
      icon: <VscProject size={22} />,
      label: 'Projects',
      onClick: () => scrollToSection('projects'),
    },
    {
      icon: <VscVscodeInsiders size={22} />,
      label: 'LinkedIn',
      onClick: () => window.open('https://www.linkedin.com/in/rishishinde2003', '_blank'),

    },
    {
      icon: <VscGithub size={22} />,
      label: 'GitHub',
       onClick: () => window.open('https://github.com/Rishishinde08', '_blank'),
    },
    
  ];

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1000,
      }}
    >
      <Dock
        items={items}
        panelHeight={70}
        baseItemSize={50}
        magnification={70}
      />
    </div>
  );
};

export default BottomDockNavbar;
